var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  width: "1.2em",
  height: "1.2em",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M6.19543 8.86182C6.45576 8.60158 6.87749 8.60158 7.13782 8.86182C7.39817 9.12217 7.39817 9.54434 7.13782 9.80469L4.276 12.6665H5.33313C5.70127 12.6665 6.00003 12.9649 6.00012 13.333C6.00012 13.7012 5.70132 14 5.33313 14H2.66663C2.29844 14 2.00012 13.7012 2.00012 13.333V10.6665C2.00012 10.2983 2.29844 10 2.66663 10C3.03482 10 3.33313 10.2983 3.33313 10.6665V11.7241L6.19543 8.86182ZM14.0001 5.33301C14.0001 5.7012 13.7013 6 13.3331 6C12.965 5.99991 12.6666 5.70114 12.6666 5.33301V4.27588L9.80481 7.1377C9.54446 7.39804 9.12229 7.39804 8.86194 7.1377C8.6017 6.87737 8.6017 6.45564 8.86194 6.19531L11.7242 3.33301H10.6666C10.2984 3.33301 10.0001 3.03469 10.0001 2.6665C10.0001 2.29831 10.2984 2 10.6666 2H13.3331C13.7013 2 14.0001 2.29831 14.0001 2.6665V5.33301Z",
      fill: "currentColor",
      "fill-opacity": "0.6157"
    }, null, -1)
  ]));
}
__name(render, "render");
const IconFullScreen = markRaw({ name: "custom-full-screen", render });
export {
  IconFullScreen as default
};
//# sourceMappingURL=full-screen.js.map
